export default __webpack_public_path__ + "static/media/surveys.43986ae2.svg";